import { render, staticRenderFns } from "./ProductStrength.vue?vue&type=template&id=04bd5da2&scoped=true&"
import script from "./ProductStrength.vue?vue&type=script&lang=js&"
export * from "./ProductStrength.vue?vue&type=script&lang=js&"
import style0 from "./ProductStrength.vue?vue&type=style&index=0&id=04bd5da2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd5da2",
  null
  
)

export default component.exports